export default __webpack_public_path__ + "static/media/briefcase.9b95c762.svg";